// en / ru / picture
export const all_words_tsv = `accordion	аккордеон	accordion.jpg
air conditioner	кондиционер	air_conditioner.jpg
airplane	самолёт	airplane.jpg
airport	аэропорт	airport.jpg
ambulance	скорая помощь	ambulance.jpg
ant	муравей	ant.jpg
apple	яблоко	apple.jpg
apricot	абрикос	apricot.jpg
arm	рука	arm.jpg
astronaut	космонавт	astronaut.jpg
avocado	авокадо	avocado.jpg
axe	топор	axe.jpg
back	спина	back.jpg
backpack	рюкзак	backpack.jpg
bacon	бекон	bacon.jpg
shuttlecock	воланчик	badminton_shuttlecock.jpg
ball	мяч	ball.jpg
balloon	воздушный шарик	balloon.jpg
banana	банан	banana.jpg
bandage	бинт	bandage.jpg
bank	банк	bank.jpg
barber	парикмахер	barber.jpg
baseball bat	бейсбольная бита	baseball_bat.jpg
basket	корзина	basket.jpg
basketball	баскетбол	basketball.jpg
bat	летучая мышь	bat.jpg
bathtub	ванна	bathtub.jpg
beach	пляж	beach.jpg
bear	медведь	bear.jpg
bed	кровать	bed.jpg
bee	пчела	bee.jpg
beetle	жук	beetle.jpg
beetroot	свёкла	beetroot.jpg
bell pepper	болгарский перец	bell_pepper.jpg
belt	ремень	belt.jpg
bib	слюнявчик	bib.jpg
bicycle	велосипед	bicycle.jpg
billboard	рекламный щит	billboard.jpg
black	чёрный	black.jpg
blanket	одеяло	blanket.jpg
blender	блендер	blender.jpg
blue	синий	blue.jpg
blueberry	черника	blueberry.jpg
boat	лодка	boat.jpg
bolt	болт	bolt.jpg
book	книга	book.jpg
bookcase	книжный шкаф	bookcase.jpg
bowl	миска	bowl.jpg
bowling ball	шар для боулинга	bowling_ball.jpg
boxing gloves	боксёрские перчатки	boxing_gloves.jpg
bracelet	браслет	bracelet.jpg
branch	ветка	branch.jpg
bread	хлеб	bread.jpg
bridge	мост	bridge.jpg
broccoli	брокколи	broccoli.jpg
broom	метла	broom.jpg
brown	коричневый	brown.jpg
bunk bed	двухъярусная кровать	bunk_bed.jpg
bus	автобус	bus.jpg
bush	куст	bush.jpg
butter	масло	butter.jpg
butterfly	бабочка	butterfly.jpg
cactus	кактус	cactus.jpg
cake	торт	cake.jpg
camel	верблюд	camel.jpg
camera	камера	camera.jpg
campfire	костёр	campfire.jpg
candle	свеча	candle.jpg
canoe	каноэ	canoe.jpg
cap	кепка	cap.jpg
car	машина	car.jpg
carpet	ковёр	carpet.jpg
carrot	морковь	carrot.jpg
castle	замок	castle.jpg
cat	кошка	cat.jpg
caterpillar	гусеница	caterpillar.jpg
celery	сельдерей	celery.jpg
cereal	хлопья	cereal.jpg
chair	стул	chair.jpg
chalk	мел	chalk.jpg
chameleon	хамелеон	chameleon.jpg
cheese	сыр	cheese.jpg
chef	повар	chef.jpg
cherry	вишня	cherry.jpg
chest	сундук	chest.jpg
chicken	курица	chicken.jpg
chocolate	шоколад	chocolate.jpg
church	церковь	church.jpg
cinema	кинотеатр	cinema.jpg
circle	круг	circle.jpg
clay	глина	clay.jpg
clock	часы	clock.jpg
cloud	облако	cloud.jpg
coat	пальто	coat.jpg
coconut	кокос	coconut.jpg
coffee	кофе	coffee.jpg
pencils	карандаши	colored_pencils.jpg
comb	расчёска	comb.jpg
comet	комета	comet.jpg
compass	компас	compass.jpg
cookie	печенье	cookie.jpg
coral	коралл	coral.jpg
corn	кукуруза	corn.jpg
cow	корова	cow.jpg
crab	краб	crab.jpg
crayons	цветные мелки	crayons.jpg
crescent	полумесяц	crescent.jpg
crocodile	крокодил	crocodile.jpg
crosswalk	пешеходный переход	crosswalk.jpg
crow	ворона	crow.jpg
crutches	костыли	crutches.jpg
cube	куб	cube.jpg
cucumber	огурец	cucumber.jpg
cup	чашка	cup.jpg
curtain	занавеска	curtain.jpg
daisy	ромашка	daisy.jpg
deer	олень	deer.jpg
dentist	дантист	dentist.jpg
diamond	бриллиант	diamond.jpg
diaper	подгузник	diaper.jpg
doctor	доктор	doctor.jpg
dog	собака	dog.jpg
doll	кукла	doll.jpg
dolphin	дельфин	dolphin.jpg
donkey	осёл	donkey.jpg
door	дверь	door.jpg
doughnut	пончик	doughnut.jpg
dragonfly	стрекоза	dragonfly.jpg
dress	платье	dress.jpg
drill	дрель	drill.jpg
drum	барабан	drum.jpg
duck	утка	duck.jpg
eagle	орёл	eagle.jpg
ear	ухо	ear.jpg
earrings	серьги	earrings.jpg
earth	Земля	earth.jpg
egg	яйцо	egg.jpg
eggplant	баклажан	eggplant.jpg
elbow	локоть	elbow.jpg
elephant	слон	elephant.jpg
envelope	конверт	envelope.jpg
eraser	ластик	eraser.jpg
eye	глаз	eye.jpg
face	лицо	face.jpg
fan	вентилятор	fan.jpg
fig	инжир	fig.jpg
finger	палец	finger.jpg
firefighter	пожарный	firefighter.jpg
fire truck	пожарная машина	fire_truck.jpg
fireworks	фейерверки	fireworks.jpg
fish	рыба	fish.jpg
flamingo	фламинго	flamingo.jpg
flashlight	фонарик	flashlight.jpg
floor	пол	floor.jpg
flour	мука	flour.jpg
flower	цветок	flower.jpg
flute	флейта	flute.jpg
fly	муха	fly.jpg
fog	туман	fog.jpg
foot	стопа	foot.jpg
fork	вилка	fork.jpg
fox	лиса	fox.jpg
french fries	картофель фри	french_fries.jpg
frisbee	фрисби	frisbee.jpg
frog	лягушка	frog.jpg
garage	гараж	garage.jpg
garden	сад	garden.jpg
garden hose	садовый шланг	garden_hose.jpg
garlic	чеснок	garlic.jpg
gecko	геккон	gecko.jpg
giraffe	жираф	giraffe.jpg
glass	стакан	glass.jpg
globe	глобус	globe.jpg
glove	перчатка	glove.jpg
gloves	перчатки	gloves.jpg
glue	клей	glue.jpg
goat	коза	goat.jpg
goldfish	золотая рыбка	goldfish.jpg
golf club	клюшка для гольфа	golf_club.jpg
goose	гусь	goose.jpg
grapefruit	грейпфрут	grapefruit.jpg
grapes	виноград	grapes.jpg
grass	трава	grass.jpg
grasshopper	кузнечик	grasshopper.jpg
grater	тёрка	grater.jpg
gray	серый	gray.jpg
green	зелёный	green.jpg
guinea pig	морская свинка	guinea_pig.jpg
guitar	гитара	guitar.jpg
hail	град	hail.jpg
hair	волосы	hair.jpg
hairbrush	щётка для волос	hairbrush.jpg
hairdryer	фен	hairdryer.jpg
hamburger	гамбургер	hamburger.jpg
hammer	молоток	hammer.jpg
hamster	хомяк	hamster.jpg
hand	рука	hand.jpg
harp	арфа	harp.jpg
hat	шляпа	hat.jpg
head	голова	head.jpg
headphones	наушники	headphones.jpg
heart	сердце	heart.jpg
heater	обогреватель	heater.jpg
helicopter	вертолёт	helicopter.jpg
helmet	шлем	helmet.jpg
hexagon	шестиугольник	hexagon.jpg
highlighter	маркер	highlighter.jpg
hippopotamus	бегемот	hippopotamus.jpg
hockey stick	хоккейная клюшка	hockey_stick.jpg
horse	лошадь	horse.jpg
hospital	больница	hospital.jpg
hot air balloon	воздушный шар	hot_air_balloon.jpg
hot chocolate	горячий шоколад	hot_chocolate.jpg
hot dog	хот-дог	hot_dog.jpg
hotel	отель	hotel.jpg
house	дом	house.jpg
hula hoop	обруч	hula_hoop.jpg
hummingbird	колибри	hummingbird.jpg
hurricane	ураган	hurricane.jpg
ice cream	мороженое	ice_cream.jpg
iron	утюг	iron.jpg
ironing board	гладильная доска	ironing_board.jpg
jacket	куртка	jacket.jpg
jellyfish	медуза	jellyfish.jpg
jet ski	водный мотоцикл	jet_ski.jpg
juice	сок	juice.jpg
jump rope	скакалка	jump_rope.jpg
kangaroo	кенгуру	kangaroo.jpg
kettle	чайник	kettle.jpg
keyboard	клавиатура	keyboard.jpg
kite	воздушный змей	kite.jpg
kiwi	киви	kiwi.jpg
knee	колено	knee.jpg
knife	нож	knife.jpg
ladder	лестница	ladder.jpg
ladybug	божья коровка	ladybug.jpg
lake	озеро	lake.jpg
lamp	лампа	lamp.jpg
laptop	ноутбук	laptop.jpg
leaf	лист	leaf.jpg
leg	нога	leg.jpg
lego	лего	lego.jpg
lemon	лимон	lemon.jpg
lemonade	лимонад	lemonade.jpg
letter	письмо	letter.jpg
level	уровень	level.jpg
library	библиотека	library.jpg
lightning	молния	lightning.jpg
lily	лилия	lily.jpg
lime	лайм	lime.jpg
lion	лев	lion.jpg
lizard	ящерица	lizard.jpg
lobster	омар	lobster.jpg
mango	манго	mango.jpg
marbles	шарики	marbles.jpg
markers	маркеры	markers.jpg
microphone	микрофон	microphone.jpg
microscope	микроскоп	microscope.jpg
microwave	микроволновка	microwave.jpg
milk	молоко	milk.jpg
mirror	зеркало	mirror.jpg
monkey	обезьяна	monkey.jpg
moon	Луна	moon.jpg
mop	швабра	mop.jpg
mosque	мечеть	mosque.jpg
mosquito	комар	mosquito.jpg
motorcycle	мотоцикл	motorcycle.jpg
mountain	гора	mountain.jpg
mouse	мышь	mouse.jpg
mouth	рот	mouth.jpg
muffin	маффин	muffin.jpg
mug	кружка	mug.jpg
mushroom	гриб	mushroom.jpg
nail	гвоздь	nail.jpg
neck	шея	neck.jpg
necklace	ожерелье	necklace.jpg
newspaper	газета	newspaper.jpg
nose	нос	nose.jpg
notebook	тетрадь	notebook.jpg
notepad	блокнот	notepad.jpg
nut	гайка	nut.jpg
ocean	океан	ocean.jpg
octopus	осьминог	octopus.jpg
oil	масло	oil.jpg
omelette	омлет	omelette.jpg
onion	лук	onion.jpg
orange	апельсин	orange.jpg
ostrich	страус	ostrich.jpg
oval	овал	oval.jpg
oven	духовка	oven.jpg
oven mitt	прихватка	oven_mitt.jpg
owl	сова	owl.jpg
pacifier	соска	pacifier.jpg
paint	краска	paint.jpg
paintbrush	кисть	paintbrush.jpg
pajamas	пижама	pajamas.jpg
palette	палитра	palette.jpg
pan	сковорода	pan.jpg
pancake	блин	pancake.jpg
panda	панда	panda.jpg
pants	брюки	pants.jpg
papaya	папайя	papaya.jpg
paper	бумага	paper.jpg
parrot	попугай	parrot.jpg
pasta	паста	pasta.jpg
peach	персик	peach.jpg
peacock	павлин	peacock.jpg
pear	груша	pear.jpg
peas	горох	peas.jpg
peeler	овощечистка	peeler.jpg
pen	ручка	pen.jpg
pencil	карандаш	pencil.jpg
penguin	пингвин	penguin.jpg
pentagon	пятиугольник	pentagon.jpg
pepper	перец	pepper.jpg
piano	пианино	piano.jpg
pie	пирог	pie.jpg
pig	свинья	pig.jpg
pillow	подушка	pillow.jpg
pilot	пилот	pilot.jpg
pineapple	ананас	pineapple.jpg
pink	розовый	pink.jpg
pizza	пицца	pizza.jpg
planet	планета	planet.jpg
plate	тарелка	plate.jpg
pliers	плоскогубцы	pliers.jpg
plum	слива	plum.jpg
police car	полицейская машина	police_car.jpg
policeman	полицейский	police_officer.jpg
pomegranate	гранат	pomegranate.jpg
popcorn	попкорн	popcorn.jpg
post office	почта	post_office.jpg
potato	картофель	potato.jpg
present	подарок	present.jpg
printer	принтер	printer.jpg
pumpkin	тыква	pumpkin.jpg
purple	фиолетовый	purple.jpg
purse	сумочка	purse.jpg
puzzle	пазл	puzzle.jpg
pyramid	пирамида	pyramid.jpg
rabbit	кролик	rabbit.jpg
racket	ракетка	racket.jpg
radish	редис	radish.jpg
rain	дождь	rain.jpg
rainbow	радуга	rainbow.jpg
raincoat	дождевик	raincoat.jpg
rake	грабли	rake.jpg
raspberry	малина	raspberry.jpg
rattle	погремушка	rattle.jpg
razor	бритва	razor.jpg
rectangle	прямоугольник	rectangle.jpg
red	красный	red.jpg
refrigerator	холодильник	refrigerator.jpg
remote control	пульт	remote_control.jpg
cafe	кафе	restaurant.jpg
rhinoceros	носорог	rhinoceros.jpg
rice	рис	rice.jpg
ring	кольцо	ring.jpg
river	река	river.jpg
road	дорога	road.jpg
rock	камень	rock.jpg
rocket	ракета	rocket.jpg
roller skates	роликовые коньки	roller_skates.jpg
rolling pin	скалка	rolling_pin.jpg
roof	крыша	roof.jpg
rooster	петух	rooster.jpg
rose	роза	rose.jpg
ruler	линейка	ruler.jpg
sailboat	парусник	sailboat.jpg
salad	салат	salad.jpg
salt	соль	salt.jpg
sand	песок	sand.jpg
sandals	сандалии	sandals.jpg
sandwich	бутерброд	sandwich.jpg
Santa Claus	Дед Мороз	santa_Claus.jpg
sausage	сосиска	sausage.jpg
saw	пила	saw.jpg
saxophone	саксофон	saxophone.jpg
scarf	шарф	scarf.jpg
school	школа	school.jpg
scissors	ножницы	scissors.jpg
scooter	самокат	scooter.jpg
screw	винт	screw.jpg
screwdriver	отвёртка	screwdriver.jpg
scrunchie	резинка для волос	scrunchie.jpg
seagull	чайка	seagull.jpg
seahorse	морской конёк	seahorse.jpg
sea turtle	морская черепаха	sea_turtle.jpg
shampoo	шампунь	shampoo.jpg
shark	акула	shark.jpg
sharpener	точилка	sharpener.jpg
sheep	овца	sheep.jpg
shelf	полка	shelf.jpg
ship	корабль	ship.jpg
shirt	рубашка	shirt.jpg
shoes	обувь	shoes.jpg
shorts	шорты	shorts.jpg
shoulder	плечо	shoulder.jpg
shovel	лопата	shovel.jpg
shower	душ	shower.jpg
sidewalk	тротуар	sidewalk.jpg
sink	раковина	sink.jpg
skate	конёк	skate.jpg
skateboard	скейтборд	skateboard.jpg
ski	лыжи	ski.jpg
skirt	юбка	skirt.jpg
skyscraper	небоскрёб	skyscraper.jpg
sled	сани	sled.jpg
sleeping bag	спальный мешок	sleeping_bag.jpg
sleigh	санки	sleigh.jpg
smartphone	смартфон	smartphone.jpg
smoothie	смузи	smoothie.jpg
snail	улитка	snail.jpg
snake	змея	snake.jpg
snow	снег	snow.jpg
snowboard	сноуборд	snowboard.jpg
snowflake	снежинка	snowflake.jpg
snowman	снеговик	snowman.jpg
soap	мыло	soap.jpg
soccer ball	футбольный мяч	soccer_ball.jpg
socks	носки	socks.jpg
sofa	диван	sofa.jpg
soup	суп	soup.jpg
sparrow	воробей	sparrow.jpg
spatula	лопатка	spatula.jpg
spider	паук	spider.jpg
spinach	шпинат	spinach.jpg
spoon	ложка	spoon.jpg
square	квадрат	square.jpg
squirrel	белка	squirrel.jpg
stadium	стадион	stadium.jpg
stairs	лестница	stairs.jpg
stamp	марка	stamp.jpg
stapler	степлер	stapler.jpg
star	звезда	star.jpg
starfish	морская звезда	starfish.jpg
stingray	скат	stingray.jpg
store	магазин	store.jpg
storm	буря	storm.jpg
stove	плита	stove.jpg
strainer	сито	strainer.jpg
strawberry	клубника	strawberry.jpg
streetlight	фонарь	streetlight.jpg
stroller	коляска	stroller.jpg
subway	метро	subway.jpg
sugar	сахар	sugar.jpg
suit	костюм	suit.jpg
sun	Солнце	sun.jpg
sunflower	подсолнух	sunflower.jpg
sunglasses	солнечные очки	sunglasses.jpg
supermarket	супермаркет	supermarket.jpg
sushi	суши	sushi.jpg
swan	лебедь	swan.jpg
sweater	свитер	sweater.jpg
swimsuit	купальник	swimsuit.jpg
syringe	шприц	syringe.jpg
table	стол	table.jpg
tablet	планшет	tablet.jpg
tape	скотч	tape.jpg
tape measure	рулетка	tape_measure.jpg
taxi	такси	taxi.jpg
tea	чай	tea.jpg
teacher	учитель	teacher.jpg
teddy bear	плюшевый мишка	teddy_bear.jpg
teeth	зубы	teeth.jpg
telephone	телефон	telephone.jpg
television	телевизор	television.jpg
temple	храм	temple.jpg
tennis racket	теннисная ракетка	tennis_racket.jpg
tent	палатка	tent.jpg
tie	галстук	tie.jpg
tiger	тигр	tiger.jpg
toast	тост	toast.jpg
toaster	тостер	toaster.jpg
toe	палец ноги	toe.jpg
toilet	туалет	toilet.jpg
tomato	помидор	tomato.jpg
tongs	щипцы	tongs.jpg
tongue	язык	tongue.jpg
toothbrush	зубная щётка	toothbrush.jpg
tornado	торнадо	tornado.jpg
towel	полотенце	towel.jpg
tower	башня	tower.jpg
traffic light	светофор	traffic_light.jpg
train	поезд	train.jpg
train station	вокзал	train_station.jpg
tram	трамвай	tram.jpg
tree	дерево	tree.jpg
triangle	треугольник	triangle.jpg
truck	грузовик	truck.jpg
t-shirt	футболка	t-shirt.jpg
tulip	тюльпан	tulip.jpg
tunnel	тоннель	tunnel.jpg
turkey	индюк	turkey.jpg
turtle	черепаха	turtle.jpg
umbrella	зонтик	umbrella.jpg
vacuum cleaner	пылесос	vacuum_cleaner.jpg
vase	ваза	vase.jpg
violet	фиолетовый	violet.jpg
violin	скрипка	violin.jpg
volcano	вулкан	volcano.jpg
volleyball	волейбол	volleyball.jpg
waffle	вафля	waffle.jpg
wall	стена	wall.jpg
wallet	бумажник	wallet.jpg
washing machine	стиральная машина	washing_machine.jpg
watch	часы	watch.jpg
water	вода	water.jpg
waterfall	водопад	waterfall.jpg
watering can	лейка	watering_can.jpg
watermelon	арбуз	watermelon.jpg
whale	кит	whale.jpg
wheelchair	инвалидное кресло	wheelchair.jpg
whisk	венчик	whisk.jpg
white	белый	white.jpg
whiteboard	доска	whiteboard.jpg
wind	ветер	wind.jpg
window	окно	window.jpg
wolf	волк	wolf.jpg
woodpecker	дятел	woodpecker.jpg
worm	червь	worm.jpg
wrench	гаечный ключ	wrench.jpg
xylophone	ксилофон	xylophone.jpg
yacht	яхта	yacht.jpg
yellow	жёлтый	yellow.jpg
mat	коврик yoga_mat.jpg
yogurt	йогурт	yogurt.jpg
yo-yo	йо-йо	yo-yo.jpg
zebra	зебра	zebra.jpg
zucchini	кабачок	zucchini.jpg`